import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { inputControl?: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      customerViewOuterContainer: {
        height: '809px',
        padding: '0 24px 24px',
        [theme.breakpoints.down('lg')]: {
          height: '1660px'
        }
      },
      customerViewInnerContainer: {
        background: 'white',
        padding: '30px 64px',
        [theme.breakpoints.down('lg')]: {
          height: '1600px',
          padding: '98px 30px 48px 30px'
        }
      },
      customerViewInputsBox: {
        flex: '1 1 0%',
        background: 'transparent',
        [theme.breakpoints.down('lg')]: {
          height: '1000px'
        }
      },
      customerViewInputsContainer: {
        padding: '0px 80px 0px 80px',
        height: props.inputControl ? '250px' : '575px',
        [theme.breakpoints.down('lg')]: {
          height: '100%',
          padding: '0px 0px 0px 0px'
        }
      },
      customerInputField: {
        [theme.breakpoints.down('lg')]: {
          minWidth: '350px !important',
          fontSize: '30px'
        }
      },
      customerInputLabel: {
        fontWeight: 600,
        fontSize: '32px',
        margin: '0px',
        [theme.breakpoints.down('lg')]: {
          fontSize: '30px'
        }
      }
    })
  );
